var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconLock = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M50.6667 29.3333H13.3333C10.3878 29.3333 8 31.7211 8 34.6667V53.3333C8 56.2789 10.3878 58.6667 13.3333 58.6667H50.6667C53.6122 58.6667 56 56.2789 56 53.3333V34.6667C56 31.7211 53.6122 29.3333 50.6667 29.3333Z",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.6667 29.3333V18.6667C18.6667 15.1304 20.0714 11.7391 22.5719 9.23858C25.0724 6.73809 28.4638 5.33333 32 5.33333C35.5362 5.33333 38.9276 6.73809 41.4281 9.23858C43.9286 11.7391 45.3333 15.1304 45.3333 18.6667V29.3333",
    stroke: "white",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-lock.07f1a3db90ce058bfe59258e6fb331a6.svg";